(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('ComplainOnSmsDetailController', ComplainOnSmsDetailController);

    ComplainOnSmsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ComplainOnSms'];

    function ComplainOnSmsDetailController($scope, $rootScope, $stateParams, previousState, entity, ComplainOnSms) {
        var vm = this;

        vm.complainOnSms = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('telestatApp:complainOnSmsUpdate', function(event, result) {
            vm.complainOnSms = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
